import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from 'shared/ui/Button';
import {
  Wrapper, CancelButton, Title, Actions
} from './styled';

const Header = ({
  disabled = false, onClose, onAccept, isJira = false, title = ''
}) => (
  <Wrapper $hasTitle={ Boolean(title) }>
    { title ? <Title>{ title }</Title> : null }
    <Actions>
      <CancelButton onClick={ onClose }>
        <FormattedMessage id="common.components.button.cancel" />
      </CancelButton>
      { !isJira && (
        <Button disabled={ disabled } onClick={ onAccept }>
          <FormattedMessage id="common.components.button.save" />
        </Button>
      ) }
    </Actions>
  </Wrapper>
);
export default Header;

Header.propTypes = {
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  title: PropTypes.string
};
